import EventDetectionLocation from './EventDetectionLocation'
import EventExpectedProductId from './EventExpectedProductId'
import EventIdAttribute from './EventIdAttribute'
import EventSubtypeAttribute from './EventSubtypeAttribute'
import EventTimeAttribute from './EventTimeAttribute'

export default {
  install( molten ) {
    molten.addPlugin( 'Attribute', EventIdAttribute )
    molten.addPlugin( 'Attribute', EventSubtypeAttribute )
    molten.addPlugin( 'Attribute', EventTimeAttribute )
    molten.addPlugin( 'Attribute', EventExpectedProductId )
    molten.addPlugin( 'Attribute', EventDetectionLocation )
  }
}
